<template>
  <router-view />
  <div class="bg-white">
    <div
      class="main-content transition"
      style="min-height: auto !important; padding-top: 0"
    >
      <MainFooter />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "./utils/store";
import { defaultLanguage, i18n } from "@/assets/i18n/i18n";
import MainFooter from "./components/Layouts/MainFooter.vue";
import { getInstance, load, ReCaptchaInstance } from "recaptcha-v3";
import config from "./utils/const/config";

export default defineComponent({
  name: "App",
  components: {
    MainFooter,
  },
  data() {
    return {
      recaptcha: undefined as ReCaptchaInstance | undefined,
    };
  },
  setup() {
    stateStore.init();
    i18n.global.locale = defaultLanguage();
  },
  async mounted() {
    if(config.recaptcha_site_key != null) {
      this.recaptcha = await load(config.recaptcha_site_key);
      if (this.$route.name !== "RequestSupport") this.recaptcha?.hideBadge();
    }
    if(config.cookie_consent_id != null) {
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', `https://consent.cookiebot.com/uc.js?cbid=${config.cookie_consent_id}`)
      document.head.appendChild(externalScript)
    }
  },
});
</script>
